import React from "react";
import hubriseIcon from "../../../assets/images/hubrise.png";

export function HubRiseIcon() {
  return (
    <div style={{ width: 56, height: 56, flexShrink: 0, display: "grid", placeItems: "center", border: "1px solid var(--gray-a6)", borderRadius: 6, background: "white" }}>
      <img src={hubriseIcon} alt="HubRise logo" width="40" height="40" style={{ objectFit: "contain" }} />
    </div>
  );
}
